const getUri = () => process.env.REACT_APP_BASE_URL;

export const getContract = async (guid) => {
    const baseUrl = getUri();
    const response = await fetch(`${baseUrl}/contract/${guid}`);

    return await response.json();
}

export const signContract = async (guid, clientIp, sigBase64, browser) => {
    const baseUrl = getUri();
    const requestUrl = `${baseUrl}/contract/${guid}/${clientIp}`;

    var _body = {
        sigBase64: sigBase64,
        browser: browser
    };

    try {
        const response = await fetch(requestUrl, {
            method: 'PUT',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(_body)
        });
        return response.json();
    } catch (err) {
        return { errorCode: err };
    }
}
